/**
 * La política de consentimiento de la marca (`GET /activa/settings` → `politicaOptIn`): con «declarada», Reactivación
 * le escribe también a quien el archivo no dice si aceptó; con «estricta», sólo a quien dijo que sí. WhatsApp oficial
 * le escribe sólo a quien dijo que sí, siempre. La usa el asistente para explicar por qué el mismo archivo le llega a
 * unos por un canal y no por el otro (`porQueDifieren`).
 *
 * Se pide la primera vez que hace falta (`activo`) y se guarda. Si no se pudo leer, `politica` queda null y
 * `cargando` false: quien la usa dice lo que vale siempre, sin inventar la política.
 */

import { useEffect, useState } from "react";
import { activaApi } from "../api";

export type PoliticaOptIn = "estricta" | "declarada";

export function usePoliticaConsentimiento(activo: boolean): { politica: PoliticaOptIn | null; cargando: boolean } {
  const [estado, setEstado] = useState<{ politica: PoliticaOptIn | null; leida: boolean }>({ politica: null, leida: false });

  useEffect(() => {
    if (!activo || estado.leida) return;
    let vivo = true;
    Promise.resolve()
      .then(() => activaApi.settings())
      .then((r: { success?: boolean; data?: { politicaOptIn?: unknown } } | undefined) => {
        if (!vivo) return;
        const v = r?.success === false ? null : r?.data?.politicaOptIn;
        setEstado({ politica: v === "estricta" || v === "declarada" ? v : null, leida: true });
      })
      .catch(() => { if (vivo) setEstado({ politica: null, leida: true }); });
    return () => { vivo = false; };
  }, [activo, estado.leida]);

  return { politica: estado.politica, cargando: activo && !estado.leida };
}
